import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Tabs, Tab, Badge } from "@material-ui/core";
import t from "../../languages/pl";

const StyledTabs = withStyles({
	indicator: {
		display: 'flex',
		justifyContent: 'center',
	},
})((props) => <Tabs {...props} />);

const StyledTab = withStyles((theme) => ({
	root: {
		marginRight: theme.spacing(1),
		'&:focus': {
			opacity: 1,
		},
	},
}))((props) => <Tab disableRipple {...props} />);

const useStyles = theme => ({
	tabs: {
		padding: theme.spacing(1)
	}
});

const ReportTabs = props => {
	const { classes, value, onTabChange, pendingReportQuantity = 0 } = props;

	return (
		<StyledTabs
			className={classes.tabs}
			value={value}
			onChange={(e, newValue) => onTabChange(newValue)}
			centered
			indicatorColor="primary"
		>
			<StyledTab label={t.pickReport} index={0} />
			<StyledTab label={t.automaticReports} index={1} />
			<StyledTab label={
					<Badge
						badgeContent={pendingReportQuantity}
						color="primary"
					>
						{t.pendingReports}
					</Badge>
				}
				index={2}
			/>
		</StyledTabs>
	);
};

ReportTabs.propTypes = {
	classes: PropTypes.object,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	pendingReportQuantity: PropTypes.number,
	onTabChange: PropTypes.func
};

export default withStyles(useStyles)(ReportTabs);
